import React from 'react';

import { useParams } from 'react-router-dom';

import { Dialog, DialogContent, DialogTitle } from '@mui/material';

import BundleItemOptionForm from './BundleItemOptionForm';

type Props = {
  bundleItemId: string;
  onClose: () => void;
};

function BundleItemOptionCreate({ bundleItemId, onClose }: Props) {
  const { bundleId } = useParams<{ bundleId: string }>();

  return (
    <Dialog open onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Add Bundle Item Option</DialogTitle>
      <DialogContent>
        <BundleItemOptionForm bundleId={bundleId} bundleItemId={bundleItemId} onClose={onClose} />
      </DialogContent>
    </Dialog>
  );
}

export default BundleItemOptionCreate;
